/** @format */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { surveyService } from '../../Services/survey.services';

const UpdateSurvey = ({ onSuccess, setResultModal, updateData, disabled }) => {
	const { t: translator } = useTranslation();
	const { register, handleSubmit, errors, setValue } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});

	useEffect(() => {
		setValue('name', updateData.name, { shouldValidate: true });
		setValue('description', updateData.description);
		setValue('content', updateData.content, { shouldValidate: true });
		setValue('validFrom', updateData.validFrom ? updateData.validFrom.substring(0, 10) : '');
		setValue('validTo', updateData.validTo ? updateData.validTo.substring(0, 10) : '');
	}, [updateData]);

	const onSubmit = data => {
		surveyService
			.update(updateData.surveyId, data)
			.then(res => {
				onSuccess();
				setResultModal({
					show: true,
					title: translator('Survey-Update-SuccessModal-Title'),
					text: translator(res.data.message),
					btnClass: 'btn btn-primary',
				});
			})
			.catch(err => console.log(err));
	};

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className='p-4'
			style={{ border: '1px solid lightgray' }}>
			<h5 className='mb-4 text-center font-weight-bold'>
				{translator('Survey-Update')}
			</h5>

			<fieldset className='scheduler-border'>
				<div className='form-group'>
					<label>{translator('Survey-Name')}</label>
					<input
						type='text'
						className='form-control'
						ref={register({ required: true, maxLength: 100 })}
						defaultValue={updateData.name}
						name='name'
						disabled={disabled}
					/>
					{errors.name && errors.name.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
					{errors.name && errors.name.type === 'maxLength' && (
						<p className='text-danger'>{translator('ValidationMsg-MaxLength100')}</p>
					)}
				</div>

				<div className='form-group'>
					<label>{translator('Survey-Description')}</label>
					<textarea
						className='form-control'
						ref={register({ maxLength: 500 })}
						defaultValue={updateData.description}
						name='description'
						rows={3}
						disabled={disabled}
					/>
					{errors.description && errors.description.type === 'maxLength' && (
						<p className='text-danger'>{translator('ValidationMsg-MaxLength500')}</p>
					)}
				</div>

				<div className='form-group'>
					<label>{translator('Survey-Content')}</label>
					<input
						type='text'
						className='form-control'
						ref={register({
							required: true,
							pattern: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i,
						})}
						defaultValue={updateData.content}
						name='content'
						disabled={disabled}
					/>
					{errors.content && errors.content.type === 'required' && (
						<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
					)}
					{errors.content && errors.content.type === 'pattern' && (
						<p className='text-danger'>{translator('ValidationMsg-InvalidUrl')}</p>
					)}
				</div>

				<div className='form-row'>
					<div className='form-group col-6'>
						<label>{translator('Survey-ValidFrom')}</label>
						<input
							type='date'
							className='form-control'
							ref={register({ required: true })}
							name='validFrom'
							disabled={disabled}
						/>
						{errors.validFrom && errors.validFrom.type === 'required' && (
							<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
						)}
					</div>

					<div className='form-group col-6'>
						<label>{translator('Survey-ValidTo')}</label>
						<input
							type='date'
							className='form-control'
							ref={register({ required: true })}
							name='validTo'
							disabled={disabled}
						/>
						{errors.validTo && errors.validTo.type === 'required' && (
							<p className='text-danger'>{translator('ValidationMsg-RequiredField')}</p>
						)}
					</div>
				</div>
			</fieldset>

			<div className='d-flex justify-content-end mt-2'>
				<button className='btn btn-primary' type='submit' disabled={disabled}>
					{translator('Btn-Save')}
				</button>
			</div>
		</form>
	);
};

export default UpdateSurvey;
